import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CadastroEmAnalise from "../pages/CadastroEmAnalise";
import TabsManager from "../pages/TabsManager";

const UsuarioCadastrado = () => {
    const user = useSelector(state => state.user);
    const navigate = useNavigate();
    
    useEffect(() => {
        const recuperarUsuarioERealizarNavegacao = async () => {
            try {
                if (user && user.situacao === 0) {
                    navigate("/concluirCadastro", { state: user });
                }
        
                if (user && user.situacao === 2) {
                    navigate("/revisarCadastro", { state: user });
                }
        
                if (user && user.situacao === 3) {
                    navigate("/", { state: user });
                }
            } catch (err) {
                console.log(err);
            }
        }

        recuperarUsuarioERealizarNavegacao();
    }, []);

    switch (user.situacao) {
        case 0:
        case 2:
            return;
        case 1:
            return <CadastroEmAnalise />;
        default:
            return <TabsManager />;
    }
}

export default UsuarioCadastrado;